/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum Whitelabel {
  NONE = 'NONE',
  HYPR_TRAINING = 'HYPR-training',
  LOCKERROOMTLV = 'lockerroomtlv',
}
